/*
 * @Author: xsong
 * @Date: 2022-05-16 11:33:25
 * @LastEditTime: 2022-05-17 17:47:03
 * @LastEditors: xsong
 * @Description:
 * @FilePath: /vue-modv-admin-cp/src/@core/mixins/tableScroll.js
 */
import {
  get_report_org_documents,
  get_report_org_folders,
  get_report_org_vaults,
  get_report_group_vaults,
  get_report_group_folders,
  get_report_group_documents,
  get_report_user_vaults,
  get_report_user_folders,
  get_report_user_documents,
  get_report_vaults,
  get_report_folders,
  get_report_documents,
  get_report_org_vaults_csv,
  get_report_org_folders_csv,
  get_report_org_documents_csv,
  get_report_group_vaults_csv,
  get_report_group_folders_csv,
  get_report_group_documents_csv,
  get_report_user_vaults_csv,
  get_report_user_folders_csv,
  get_report_user_documents_csv,
  get_report_vaults_csv,
  get_report_folders_csv,
  get_report_documents_csv
} from '@modv/sdk'
import { blobProcess } from '@core/utils/files'
import { closeLoadingMask, openLoadingMask } from '@core/utils/elementUtil'
import { mapGetters } from 'vuex'
import { messageChannelOn } from '@core/utils/message'

const apiMapping = {
  organisation: {
    vault: [get_report_org_vaults, get_report_org_vaults_csv],
    folder: [get_report_org_folders, get_report_org_folders_csv],
    document: [get_report_org_documents, get_report_org_documents_csv]
  },
  group: {
    vault: [get_report_group_vaults, get_report_group_vaults_csv],
    folder: [get_report_group_folders, get_report_group_folders_csv],
    document: [get_report_group_documents, get_report_group_documents_csv]
  },
  user: {
    vault: [get_report_user_vaults, get_report_user_vaults_csv],
    folder: [get_report_user_folders, get_report_user_folders_csv],
    document: [get_report_user_documents, get_report_user_documents_csv]
  },
  admin: {
    vault: [get_report_vaults, get_report_vaults_csv],
    folder: [get_report_folders, get_report_folders_csv],
    document: [get_report_documents, get_report_documents_csv]
  }
}
const csv = 1
const search = 0

export function getApi(type, type2, apiIndex) {
  return apiMapping[type][type2][apiIndex]
}

export default {
  props: {
    type: {
      type: String,
      default: 'organisation'
    }
  },
  data() {
    return {
      tableData: [],
      table_loading: false,
      canFirst: false,
      type2: 'vault',
      fetchParam: {
        filter: {},
        direction: 'DESC',
        page: 0,
        pageSize: 40,
        size: 40,
        sortProperty: 'id',
        sortProperties: [],
        queries: [],
        conditions: []
      },
      maxPage: 0,
      total: '', // 总数
      selectRows: [],
      show: false
    }
  },
  computed: {
    ...mapGetters('search', ['searchText'])
  },
  mounted() {
    const that = this
    messageChannelOn(`search${this.eventName}`, function() {
      that.search(true)
    })
    messageChannelOn(`downloadCsv${this.eventName}`, function() {
      that.downloadCsv()
    })
    this.loadMore()
  },
  methods: {
    setSelectRows(val) {
      this.selectRows = val
    },
    async loadMore() {
      !this.canFirst && (await this.fetch())
      this.canFirst = true
      if (this.maxPage > this.fetchParam.page + 1) {
        this.fetchParam.page += 1
        await this.fetch()
      }
    },
    onResize() {
      this.show = !this.show
    },
    search(search = false) {
      if (search) {
        this.fetchParam.page = 0
        this.tableData = []
        this.canFirst = true
      }
      this.fetch()
    },
    async fetch() {
      const organisationId = this.$route.params[`organisationId`]
      const groupId = this.$route.params[`groupId`]
      const userId = this.$route.params[`userId`]
      const keywords = this.searchText
      this.table_loading = true
      const api = getApi(this.type, this.type2, search)
      const { page, size, sortBy, direction } = this.fetchParam
      const { data } = await api({
        keywords,
        organisationId,
        groupId,
        userId,
        $queryParameters: {
          page,
          size,
          sortBy,
          direction
        }
      })
      this.tableData = [...this.tableData, ...data.content]
      this.maxPage = data.totalPages
      this.table_loading = false
      return data
      //   try {
      //     if (reload) {
      //       this.fetchParam.page = 0
      //       this.tableData = []
      //     }
      //     this.loading = true
      //     this.fetchParam.filter = JSON.parse(JSON.stringify(formInline))
      //     this.filter = this.fetchParam.filter
      //     const res = await this.searchApi(this.fetchParam)
      //     this.tableData = [...this.tableData, ...res.data.content]
      //     this.maxPage = res.data.totalPages
      //   } catch (e) {
      //     console.error(e)
      //   } finally {
      //     this.loading = false
      //   }
    },
    async downloadCsv() {
      openLoadingMask()
      const organisationId = this.$route.params[`organisationId`]
      const groupId = this.$route.params[`groupId`]
      const userId = this.$route.params[`userId`]
      const api = getApi(this.type, this.type2, csv)

      const res = await api({
        organisationId,
        groupId,
        userId,
        $config: {
          responseType: 'blob'
        }
      })
      blobProcess(res)
      closeLoadingMask()
    }
  }
}
